import { makeAutoObservable } from "mobx";
import DataManager from "react-sdk/haxelibs/DataManager";
import SequencesManager from "react-sdk/haxelibs/SequencesManager";
import PopupsManager from "react-sdk/PopupsManager";
import SoundPlayer from "react-sdk/SoundPlayer";
import AppState, { POPUPS } from "./AppState";
import Chapters from "./Chapters";
import Ftues from "./Ftues";
import Minigames from "./Minigames/Minigames";
import SaveGame from "./SaveGame";
import Slides from "./Slides";
import ObjectivesLib from "react-sdk/haxelibs/ObjectivesLib";

class SequenceScenario {
  /** @type {succubus_sequences_Sequence} */
  mainSeq = null;
  //currentElement = null;
  onEnd = null;

  constructor() {
    makeAutoObservable(this);
  }

  init() {


    // NOTE ceci sont les actions/getters appelés depuis les fichiers .data de scénario

    DataManager.scriptManager.registerAction("executeSequence", (fileId, lineId, done) => {
      this.playSequence(fileId, lineId, done)
    }, false, true);


    DataManager.scriptManager.registerAction("showImage", (imgUrl, done) => {
      PopupsManager.open(POPUPS.IMG_FS, {imgUrl:imgUrl, onValid:done});
    }, false, true);


    DataManager.scriptManager.registerAction("showDialSequence", (fileId, lineId, done) => {
      AppState.dials.playSequence(fileId, lineId, done);
    }, false, true);


    DataManager.scriptManager.registerAction("showPlaceholderPopup", (text, done) => {
     PopupsManager.open(POPUPS.PLACEHOLDER,{ content:text, onValid:done })
    }, false, true);

    DataManager.scriptManager.registerAction("endChapter", () => {
      let isLast = AppState.currentChapter.isLast
      AppState.terminateCurrentChapter()
      if (isLast)
        AppState.showEndScreen();
      else
        AppState.goBackToModulesChoiceScreen();
    }, false, false);
    
    DataManager.scriptManager.registerAction("showFTUE", (id, done) => {
      // if (Ftues.hasBeenViewed(id))
      //   done()
      // else
        PopupsManager.open(POPUPS.FTUE, id, () => {
          // if (id !== "warning_evaluation" && id !== "warning_evaluation_done" ) // cas particulier : on veut afficher ça à plusieurs moments
          //   Ftues.addViewed(id)
          done()
        })
    }, false, true);

    DataManager.scriptManager.registerAction("showSlide", (id, done) => {
      if (AppState.skipAct)
        done()
      else {
        let slide = Slides.get(id);
        if (slide)
          PopupsManager.open(POPUPS.SLIDES, id, done)
        else
          done();
      }
    }, false, true);



    DataManager.scriptManager.registerAction("showMinigameIntro", (id, done) => {
      if (AppState.skipAct)
        done()
      else {
        let mg = Minigames.get(id);
        if (mg)
          PopupsManager.open(POPUPS.MINIGAME_INTRO, mg, done)
        else
          done();
      }
    }, false, true);

    DataManager.scriptManager.registerAction("showMinigame", (id, done) => {
      if (AppState.skipAct)
        done()
      else {
        Minigames.play(id, done)
        //console.log(Minigames.history);
      }
    }, false, true);

    
    DataManager.scriptManager.registerAction("showMinigameStars", (id, done) => {
      if (AppState.skipAct)
        done()
      else {
        let mg = Minigames.get(id);
        if (mg)
          PopupsManager.open(POPUPS.MINIGAME_STARS, mg, done)
        else
          done();
      }
    }, false, true);

    DataManager.scriptManager.registerAction("computeChapterResult", (mgIds) => {
      AppState.currentChapter.computeResult(mgIds)
    }, false, false);
    DataManager.scriptManager.registerFunction("getCurrentChapterStars", () => {
      return AppState.currentChapter.lastStarsNb;
    }, false);

    DataManager.scriptManager.registerAction("showChapterEndPopup", (done) => {
      PopupsManager.open(POPUPS.CHAPTER_END, AppState.currentChapter, done)
    }, false, true);


    DataManager.scriptManager.registerAction("saveGame", () => {
      SaveGame.save()
    }, false, false);

    DataManager.scriptManager.registerAction("showUIelement", (id, visible) => {
      AppState.UI_visibilities = {...AppState.UI_visibilities, [id]: visible}
      SaveGame.updateState()
    }, false, false)

    DataManager.scriptManager.registerAction("forceClickUIelement", (id) => {
      AppState.forceClickUIElements = {...AppState.forceClickUIElements, [id]: true}
      SaveGame.updateState()
    }, false, false)

    DataManager.scriptManager.registerAction("enableUI", (visible) => {
      AppState.hudVisibility = visible;
    }, false, false);

    DataManager.scriptManager.registerAction("openMapAndWaitValidateNextLocation", (poiTarget, done) => {
      console.log("openMapAndWaitValidateNextLocation");

      var saveUiState = { ...AppState.UI_visibilities };

      AppState.UI_visibilities.clipboardBtn = false;
      AppState.UI_visibilities.folderBtn = false;
      AppState.UI_visibilities.helpBtn = false;
      AppState.UI_visibilities.meetingBtn = false;
      AppState.UI_visibilities.objectiveBar = false;
      AppState.UI_visibilities.nextButton = true;

      AppState.reaxe_api.toHaxe("game", "openMap", { poiToHighLight : poiTarget});
      AppState.nextButtonCallBack = ()=>{

          AppState.reaxe_api.toHaxe("game", "fakeclickOnMapPoi", { poiToClick : poiTarget}).then(()=>{done();});
          AppState.UI_visibilities = saveUiState;
        }
    }, false, true);

     DataManager.scriptManager.registerAction("setChildPoi", (poiId, done) => {
       AppState.reaxe_api.toHaxe("game", "setChildPoi", { poiId : poiId}).then(()=>{done();});
    }, false, true)
    
    DataManager.scriptManager.registerAction("playSFX", (id, waitEnd, done) => {
      if (waitEnd)
        SoundPlayer.playSound(id, done)
      else {
        SoundPlayer.playSound(id)
        done()
      }

    }, false, true)

    DataManager.scriptManager.registerAction("lockHUD", (val) => {
      AppState.lockHud = val
    }, false, false)

    DataManager.scriptManager.registerAction("sendStandardTrigger", (triggerValue) => {
      AppState.reaxe_api.toHaxe("game", "triggerScript", { trigger : "Standard", triggerValue : triggerValue})
    }, false, false);

    DataManager.scriptManager.registerAction("playChildAnimation", (animId, done) => {
      AppState.reaxe_api.toHaxe("game", "playCharacterAnimation", { entityId : "enfant", animation:animId, loop:false}).then(()=>{if(done) done();});
    }, false, true);

    DataManager.scriptManager.registerAction("refreshObjectives", (dirty, done) => {
      if (dirty) {
        AppState.objectives.dirtyRefresh();
        done();
      } else
        ObjectivesLib.refresh(null, (hasChanged, hasProgresschanged) => done());
    }, false, true);

  }

  addFile(fileId) {
    SequencesManager.createFileFromId(fileId);
  }

  playSequence(fileId, lineId, onEnd) {

    this.mainSeq = SequencesManager.playElement(fileId, lineId);
    if (this.mainSeq) {
      this.onEnd = onEnd;
      this.next();
    } else
      onEnd();
  }

  next() {
    this.mainSeq.next(element => {
      //this.currentElement = element
      if (element)
        this.next();
      else
        this.quit();
    });
  }

  quit() {
    //SoundPlayer.playSound("music_map");
    this.mainSeq = null;
    //this.currentElement = null;
    //AppState.dials.deleteAllCharacters();

    //AppState.soloObjectives.refresh()

    // ObjectivesLib.refresh();
    if (this.onEnd) this.onEnd();

    this.onEnd = null;
  }

  unlockChildFolderId(childFolderId, done){
    if (AppState.skipBlocNote) {
      AppState.childFolderData.unlock(childFolderId);
      done();
    } else
    AppState.childFolderData.unlock(childFolderId, () => {
        setTimeout(() => done(), 10);
      });
  }

  unlockClipboardId(clipBoardId, done){
    if (AppState.skipBlocNote) {
      AppState.clipBoardData.unlock(clipBoardId);
      done();
    } else
    AppState.clipBoardData.unlock(clipBoardId, () => {
        setTimeout(() => done(), 10);
      });
  }

}

export default new SequenceScenario();
